import { t } from "i18next"
import moment from "moment"
import * as Yup from "yup"

export const reminderValidationSchema = Yup.object().shape({
  recertification: Yup.object().shape({
    isActive: Yup.boolean(),

    startDate: Yup.string()
      .nullable()
      .when("isActive", {
        is: (value) => value === true,
        then: (schema) =>
          schema
            .required(t(`learning.admin.settings.validation.recertification_start_date`, "Select start date"))
            .test(
              "valid-start",
              t(
                `learning.admin.settings.validation.recertification_start_date_invalid`,
                "Start date is invalid"
              ),
              (v) => (v ? moment(v).isValid() : false)
            )
            .test(
              "start-not-before-today",
              t(
                "validation.recertification_start_date_not_before_today",
                "Start date cannot be earlier than today"
              ),
              function (v) {
                if (!v) return false

                const d = moment(v).startOf("day")
                const today = moment().startOf("day")

                const hasStarted = d.isBefore(today)
                if (hasStarted) return true

                return d.isSameOrAfter(today)
              }
            )
      }),

    endDate: Yup.string()
      .nullable()
      .when(["isActive", "startDate"], {
        is: (isActive) => isActive === true,
        then: (schema) =>
          schema
            .required(t(`learning.admin.settings.validation.recertification_end_date`, "Select end date"))
            .test(
              "valid-end",
              t(`learning.admin.settings.validation.recertification_end_date_invalid`, "End date is invalid"),
              (v) => (v ? moment(v).isValid() : false)
            )
            .test(
              "end-after-start",
              t(
                `learning.admin.settings.validation.recertification_end_date_after_start`,
                "End date must be after start date"
              ),
              function (end) {
                const { startDate } = this.parent
                if (!end || !startDate) return false

                const start = moment(startDate).startOf("day")
                const e = moment(end).startOf("day")

                return e.isAfter(start)
              }
            )
      })
  }),

  reminders: Yup.array().of(
    Yup.object().shape({
      context: Yup.number().required(),
      timing: Yup.number().required(),
      daysOffset: Yup.number().required()
    })
  )
})
